import { render, staticRenderFns } from "./elastic-category-filter-main-item.vue?vue&type=template&id=92ac4c10"
import script from "./elastic-category-filter-main-item.vue?vue&type=script&lang=js"
export * from "./elastic-category-filter-main-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports